import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = {
  key: 3,
  class: "dataTable"
}
const _hoisted_4 = { class: "bandeau-container" }
const _hoisted_5 = { class: "btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCommand = _resolveComponent("ModalCommand")!
  const _component_DocuSignModal = _resolveComponent("DocuSignModal")!
  const _component_ModalRefuse = _resolveComponent("ModalRefuse")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_StatusTag = _resolveComponent("StatusTag")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalCommand, {
      id: _ctx.numeroVersion,
      isOpen: _ctx.isOpenCommandModal,
      isElectronicSigningPossible: _ctx.isFichierPdfPresent,
      objet: _ctx.objet,
      montant: _ctx.prix,
      monnaie: _ctx.monnaie,
      initialNumCommande: _ctx.numCommande ? `${_ctx.numCommande}` : '',
      isLoading: _ctx.isLoadingCommand,
      errorMessage: _ctx.commandErrorMessage,
      onCommanderDevis: _ctx.commanderDevis,
      onCommanderDevisSignatureElectronique: _ctx.commanderDevisSignatureElectronique,
      onCancel: _ctx.closeCommandModal
    }, null, 8, ["id", "isOpen", "isElectronicSigningPossible", "objet", "montant", "monnaie", "initialNumCommande", "isLoading", "errorMessage", "onCommanderDevis", "onCommanderDevisSignatureElectronique", "onCancel"]),
    _createVNode(_component_DocuSignModal, {
      isOpen: _ctx.isDocuSignModalOpen,
      url: _ctx.docuSignUrl,
      devisNumero: _ctx.numeroVersion,
      onClose: _ctx.onCancelSignature,
      onSignatureEvent: _ctx.onSignatureEvent
    }, null, 8, ["isOpen", "url", "devisNumero", "onClose", "onSignatureEvent"]),
    _createVNode(_component_ModalRefuse, {
      onSelectRefuse: _ctx.selectRefuse,
      onRefuseCancel: _ctx.refuseCancel,
      onRefuseConfirm: _ctx.refuseConfirm,
      onSetCommentValue: _ctx.setCommentValue,
      id: _ctx.$route.params.value,
      commentValue: _ctx.commentValue,
      isOpen: _ctx.isOpenModalRefuse,
      refuseSelected: _ctx.refuseSelected
    }, null, 8, ["onSelectRefuse", "onRefuseCancel", "onRefuseConfirm", "onSetCommentValue", "id", "commentValue", "isOpen", "refuseSelected"]),
    (_ctx.isOpenSuccessModal)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 0,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenSuccessModal = false)),
          title: _ctx.successMessage
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('devis.singlePage.title')) + " " + _toDisplayString(_ctx.$route.params.value) + " ", 1),
          _createVNode(_component_ReglePastille, { cle: "devis.definition" }),
          _createVNode(_component_ReglePastille, { cle: "devisDetail.actionsSelonStatut" })
        ])
      ]),
      _createVNode(_component_BorderedIconButton, {
        title: "RETOUR",
        imgUrl: _ctx.imgUrl,
        className: "back-btn",
        onClick: _ctx.$router.back
      }, null, 8, ["imgUrl", "onClick"]),
      (_ctx.status !== null)
        ? (_openBlock(), _createBlock(_component_StatusTag, {
            key: 0,
            status: _ctx.status
          }, null, 8, ["status"]))
        : _createCommentVNode("", true),
      (_ctx.devisData)
        ? (_openBlock(), _createBlock(_component_DataList, {
            key: 1,
            data: _ctx.devisData
          }, null, 8, ["data"]))
        : _createCommentVNode("", true),
      (_ctx.isLoadingInterventions)
        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 2 }))
        : (_ctx.interventions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.countinterventions) + " " + _toDisplayString(_ctx.$tc('intervention.dataTable.title', _ctx.countinterventions)), 1),
              _createElementVNode("div", {
                ref: "content",
                onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                class: "datatable-container"
              }, [
                _createVNode(_component_DataTable, {
                  count: _ctx.interventions.length,
                  "table-data": _ctx.tableInterventionsData,
                  "table-header": _ctx.tableHeaderInterventions,
                  onSort: _ctx.doSort
                }, null, 8, ["count", "table-data", "table-header", "onSort"])
              ], 544)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          disabled: !_ctx.isFichierPdfPresent,
          className: 'whiteBtn',
          text: _ctx.$t('seePDF'),
          onClick: _ctx.seePDF
        }, null, 8, ["disabled", "text", "onClick"]),
        _createVNode(_component_ReglePastille, { cle: "devisDetail.pdfDisponible" }),
        (_ctx.validStatus())
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              className: 'redBtn',
              text: _ctx.$t('refuse'),
              onClick: _ctx.refuse
            }, null, 8, ["text", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.validStatus())
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              className: 'greenBtn',
              text: _ctx.$t('command'),
              onClick: _ctx.command
            }, null, 8, ["text", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.validStatus())
          ? (_openBlock(), _createBlock(_component_ReglePastille, {
              key: 2,
              cle: "devisDetail.commanderDeuxModes"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}